var $ = global.jQuery = global.$;
var parser = require('../lib/parser');
var ps = require('../lib/ps');
var widgets = require('../lib/widgets');
var doT = require('dot');

var _find = require('lodash/collection/find');
var _findIndex = require('lodash/array/findIndex');
var _isEqual = require('lodash/lang/isEqual');

var Form = require('./Form');

doT.templateSettings.doNotSkipEncoded = true;

var templates = {
  news: require('../templates/filters/news.dot'),
  careers: require('../templates/filters/careers.dot'),
  downloads: require('../templates/filters/downloads.dot'),
  gallery: require('../templates/filters/gallery.dot'),
  search: require('../templates/filters/search.dot')
};

/**
 * Filters widget for news, downloads, images etc.
 * @class
 * @extends Form
 */
var Filters = Form.extend(
  /** @lends Filters.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this._super();

    this.queryRunning = 0;

    this.loadingMessage = this.$el.find('.loading').clone();

    this.itemDesc = [];

    this.queryUrl = this.$el.attr('action');
    this.page = 1;
    this.itemTemplate = templates[this.$el.data('itemTemplate')];

    this.$filterArea = this.$el.find('[data-filters]');
    this.$itemArea = this.$el.find('[data-filter-items]');
    this.$loadMore = this.$el.find('[data-load-more]');
    this.$itemsPerPage = this.$el.find('[data-items-pp]');

    this.$messageAppendArea = this.$itemArea;

  },
  /**
   * Fires once when all widgets are loaded
   * @private
   */
  onWidgetsReady: function() {
    var self = this;

    this.currentCriteria = $.extend(true, {}, this.fields);

    this.bindEvents();

    this.rows = widgets.getDescendants(this.$el, 'FilterRow');
    this.itemArea = widgets.getWidget('itemArea');
    this.pagination = widgets.getDescendants(this.$el, 'Pagination')[0];

    this.queryRunning = true;

    setTimeout(function() {
      self.getItems({
        criteria: $.extend(true, self.getFieldData(), self.$el.data('criteria'))
      });
    }, 100);
  },
  /**
   * Bind filter/paging/loading and items per page click/change events
   */
  bindEvents: function() {
    this.$loadMore.on('click', {self: this}, this._loadMoreClickHandler);
    this.$el.on('Paging:clickTriggered', {self: this}, this._pagingClickHandler);
    this.$el.on('Row:changed', {self: this}, this._rowChangeHandler);
    this.$itemsPerPage.on('Field:updated', {self: this}, this._itemsPerPageChangeHandler);
  },
  /**
   * Handle paging clicks
   * @param {object} event
   * @param {number} page The new page number
   * @private
   */
  _pagingClickHandler: function(event, page) {
    var self = event.data.self;
    var params = {
      clickTriggered: true
    };
    if (self.rows && self.rows.length > 0) {
      params.fieldName = self.rows[self.rows.length - 1].Name;
    }
    if (page !== self.page) {
      self.page = page;
      self.getItems(params);
    }
  },
  /**
   * Handle load more clicks
   * @param {object} event
   * @private
   */
  _loadMoreClickHandler: function(event) {
    var self = event.data.self;
    var iconToggle = widgets.registry[$(this).attr('id')];
    var $this = $(this);
    $this.attr('disabled', 'disabled');

    event.preventDefault();

    self.page++;

    setTimeout(function() {
      self.getItems({
        fieldName: self.rows[self.rows.length - 1].Name,
        clickTriggered: false,
        append: true
      }).always(function() {
        iconToggle.toggle();
        $this.removeAttr('disabled');
      });
    }, 1500);
  },
  /**
   * Handle changes in the filters
   * @param {object} event
   * @param {string} name The name of the field/row that changed
   * @param {string} value The new field value
   * @private
   */
  _rowChangeHandler: function(event, name, value) {
    var self = event.data.self;
    self.resetRows($(event.target).index());
    self.filterQueryHandler(name,value,true);
  },
  /**
   * Handle changes of the items per page field
   * @param {object} event
   * @param {string} name The name of the items per page field
   * @param {string} value The new value of the items per page field
   * @private
   */
  _itemsPerPageChangeHandler: function(event, name, value) {
    var self = event.data.self;
    self.filterQueryHandler(name,value);
  },
  /**
   * Handle new filter queries
   * @param {string} name The name of the items per page field
   * @param {string} value The new value of the items per page field
   * @param {boolean} [passFieldName] Whether or not to pass the field name through to the query. Basically if it's a fiter row change then we pass the field name (so the query can determine which field index changed)
   */
  filterQueryHandler: function(name, value, passFieldName) {
    var self = this;
    var params = passFieldName ? {
      fieldName: name
    } : null;
    setTimeout(function() {
      if (!_isEqual(self.currentCriteria, self.fields)) {
        self.currentCriteria = $.extend(true, {}, self.fields);
        self.getItems(params);
      }
    }, 100);
  },
  /**
   * Get a field:value mapping that the query is expecting
   * @returns {object} An object containing the field name:value pairs of the underlying forms current fields
   */
  getFieldData: function() {
    var data = {};

    for (var field in this.fields) {
      if (this.fields.hasOwnProperty(field)) {
        data[field] = this.fields[field].value;
      }
    }

    return data;
  },
  /**
   * Handle a successful AJAX call response for the get items method
   * @param {object} response The JSON response containing the response
   * @param {number} queryNo Which query number this is. Used to determine whether to output the response from this query or not (in case multiple fields have been changed in quick succession)
   * @param {number} fieldIndex The index of the field that changed. Passed to the updateFilters method so that only filters after that index get updated.
   * @param {object} params The various parameters that have been passed to the getItems query
   * @param {object} fieldData The fields that have been passed to the query
   * @private
   */
  _getItemsSuccessHandler: function(response,queryNo,fieldIndex,params,fieldData) {
    var self = this;
    if (self.queryRunning === queryNo && response.Error && response.Error !== '') {
      self.showMessage(response.Error);
      self.pagination.totalPages = 1;
      self.pagination.goToPage(1, false);
      self.page = 1;
    } else if (self.queryRunning === queryNo) {
      self.lastFieldIndex = fieldIndex;
      if (response.Value.Filters && response.Value.Filters.length > 0) {
        self.updateFilters(response.Value.Filters, fieldIndex);
      }
      self.updateItems(response.Value.Items, params.append);
      if (self.pagination) {
        self.pagination.totalPages = response.Value.Items.length === 0 ? 1 : response.Value.TotalPages;
        self.pagination.goToPage(response.Value.Items.length === 0 ? 1 : response.Value.Page, params.clickTriggered);
      }

      if (response.Value.Page === response.Value.TotalPages) {
        self.$loadMore.hide();
      } else {
        self.$loadMore.show();
      }

      self.page = response.Value.Items.length === 0 ? 1 : response.Value.Page;

      self.$el.trigger('filters:AllUpdated', [response, fieldData]);
    }
  },
  /**
   * Handle a failed AJAX call response for the get items method
   * @private
   */
  _getItemsFailHandler: function() {
    var self = this;
    self.showMessage('The server couldn\'t be reached right now, please try again later');
    self.pagination.totalPages = 1;
    self.pagination.goToPage(1, false);
    self.page = 1;
  },
  /**
   * Make a new request to the query URL
   * @param {object} [params] The parameters to pass to the query
   * @param {bool} params.append Whether or not to replace or append the returned items
   * @param {string} params.fieldName The fieldName that invoked the call
   * @param {object} params.criteria Passed along with the first call to filters. These are the values in the data-criteria attribute on page load
   * @returns {object} Returns the ajax request object
   */
  getItems: function(params) {
    params = params ? params : {};
    var self = this;
    var data = this.getFieldData();
    var queryNo = 0;
    var prevHeight = this.$itemArea.height();
    var fieldIndex = params.fieldName ? _findIndex(this.rows, {
      'Name': params.fieldName
    }) : 0;

    this.queryRunning++;
    queryNo = this.queryRunning;

    if (!params.append) {
      this.$itemArea
        .height(prevHeight)
        .empty()
        .append(this.loadingMessage);
    }

    data = params.criteria ? params.criteria : data;
    data.Page = data.Page ? data.Page : this.page;

    var req = $.ajax({
        type: 'GET',
        contentType: 'application/json',
        url: self.queryUrl,
        data: data
      })
      .done(function(response) {
        self._getItemsSuccessHandler.call(self,response,queryNo,fieldIndex,params,data);
      })
      .fail(this._getItemsFailHandler.bind(this));

    return req;
  },
  /**
   * Update the filters with the returned filter values
   * @param {object} newFilters The new filters (as returned from the getItems query)
   * @param {number} startIndex The index of the field that invoked the query (we only update the filters after this index)
   */
  updateFilters: function(newFilters, startIndex) {
    var self = this;
    var rowTmpl = require('templates/filterRow.dot');

    $.each(self.rows, function(index) {
      var matchedNewfilter = _find(newFilters, {
        Name: this.Name
      });
      if (!matchedNewfilter && index > startIndex) {
        this.$el.remove();
        delete self.fields[this.Name];
      }
    });

    $.each(newFilters, function(index) {
      if (index >= startIndex) {
        var matchedRow = _find(self.rows, {
          Name: this.Name
        });
        if (matchedRow && index > startIndex) {
          matchedRow.updateOptions(this.Options);
        } else if (!matchedRow) {
          this.rowIndex = index;
          self.$filterArea.append(rowTmpl(this));
        }
      }
    });

    if (self.$filterArea.length > 0) {
      parser.parse(self.$filterArea, function() {
        self.rows = widgets.getDescendants(self.$el, 'FilterRow');
      });
    } else {
      self.rows = [];
    }

    parser.parse(self.$itemArea);
  },
  /**
   * Reset rows after the startIndex
   * @param {number} startIndex The index from which to reset the rows (all rows after this index will be reset)
   */
  resetRows: function(startIndex) {
    $.each(this.rows, function(index) {
      if (index > startIndex) {
        this.reset();
      }
    });
  },
  /**
   * Empty the item area
   */
  emptyItems: function() {
    var self = this;

    $.each(self.itemDesc, function() {

      if (typeof this.onRemove === 'function') {
        this.onRemove();
      }
    });

    this.$itemArea
      .empty();

  },
  /**
   * Update the displayed items
   * @param {array} items The array of new items to add to the item area
   * @param {bool} append Whether or not to append the new items. If false/null will
   */
  updateItems: function(items, append) {
    var self = this;

    if (!append) {
      this.emptyItems();
    }

    if (items.length === 0) {
      this.emptyItems();
      this.showMessage('No results for those criteria, please try again');
    }

    $.each(items, function(index) {
      var that = this;
      setTimeout(function() {
        that.itemIndex = index;
        self.$itemArea.append(self.renderItem(that));
      }, index * 100);
    });

    if (this.itemArea) {
      setTimeout(function() {
        self.itemArea.getTargets();
        self.itemArea.equalise();
        parser.parse(self.$itemArea, function() {
          self.itemDesc = widgets.getDescendants(self.$itemArea);
        });
        self.attachItemEvents();
        self.$itemArea.find('[disabled]').removeAttr('disabled');
        self.$itemArea.find('.is-disabled').removeClass('is-disabled');
      }, items.length * 100);
    }

    this.$itemArea.height('auto');

  },
  /**
   * Render an item using the item template
   * @param {object} item The item to pass through the template
   */
  renderItem: function(item) {
    return this.itemTemplate(item);
  },
  /**
   * Show a message in the filter area
   * @param {string} message The message to show
   */
  showMessage: function(message) {
    this.$messageAppendArea.html('<p class="filter-message">' + message + '</p>');
  },
  /**
   * Attach any events to the items themselves
   */
  attachItemEvents: function() {
    var self = this;
    self.$itemArea.find('[data-controls]').on('click', {self:this}, this._itemControlsClickHandler);
  },
  /**
   * Handle clicks on the `[data-controls]` links for item filters
   * @private
   */
  _itemControlsClickHandler: function(event) {
    var self = event.data.self;
    var val = $(this).data('value') ? $(this).data('value') : $(this).text();
    event.preventDefault();
    $('select[name=' + $(this).data('controls') + ']')
      .val(val)
      .trigger('change');
  }
});

module.exports = Filters;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/Filters.js
 ** module id = 241
 ** module chunks = 0 1
 **/